import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoCustomTable,
    convertPersianDateToUniversalDate,
    showErrorMessage,
    RaikoCustomSimpleActiveDeActiveChip,
    convertUniversalDateTimeToPersianDateTime,
    RaikoCustomTooltip,
    DialogSize,
    RaikoDefaultDialogPage,
    RaikoTableSearchContainer,
    RaikoNumberInputOutlined,
    RaikoMaterialOutlinedInput,
    RaikoTableTitleContainer,
    RaikoDatePicker,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoBreadcrumb, raikoBreadCrumbItemGenerator
} from "@moeindal/base-raiko-panel-components";
import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {useAuthState} from "../../context/AuthContext";
import {AccountTransactionsService} from "../../serverService/accountTransactions/AccountTransactionsService";
import {dateIsNotValid, stringIsEmpty} from "../../util/VariableChecker";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import RaikoShowPrice from "../../raikoComponents/raikoShowPrice/RaikoShowPrice";
import AccountMonthlyDepositReceipt from "../accounts/detail/accountMonthlyDepositReceipt/AccountMonthlyDepositReceipt";
import {addFiltersToUrl} from "../../util/FiltersHelper";
import AccountMonthlyDepositNewTransaction from "../accounts/detail/AccountMonthlyDepositNewTransaction";

export default function AccountTransactions() {

    const {fundID} = useAuthState()
    const service = new AccountTransactionsService()

    const [searchParam, setSearchParam] = useSearchParams();
    const [page, setPage] = useState(searchParam.get("page") || 1);
    const size = 20

    const navigate = useNavigate()

    const [fullName, setFullName] = useState(searchParam.get("name") || "")
    const [nationalCode, setNationalCode] = useState(searchParam.get("national-code") || "");
    const [groupName, setGroupName] = useState(searchParam.get("group-name") || "");
    const [groupCode, setGroupCode] = useState(searchParam.get("group-code") || "");
    const [accountCode, setAccountCode] = useState(searchParam.get("account-code") || "");
    const [payAt, setPayAt] = useState(searchParam.get("pay-at") || "")
    const [submitAt, setSubmitAt] = useState(searchParam.get("submit-at") || "");
    const [payerType, setPayerType] = useState(searchParam.get("payer") || "ALL");


    const filterFullName = useDebounce(fullName, 300)
    const filterNationalCode = useDebounce(nationalCode, 300)
    const filterGroupName = useDebounce(groupName, 300)
    const filterAccountCode = useDebounce(accountCode, 300)
    const filterGroupCode = useDebounce(groupCode, 300)
    const filterPayAt = useDebounce(payAt, 300)
    const filterSubmitAt = useDebounce(submitAt, 300)
    const filterPayerType = useDebounce(payerType, 300)


    const [transactions, setTransactions] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);


    useEffect(() => {
        getTransactions()
        prepareFiltersParam()

    }, [
        page,
        filterFullName,
        filterNationalCode,
        filterGroupName,
        filterAccountCode,
        filterGroupCode,
        filterPayAt,
        filterSubmitAt,
        filterPayerType
    ]);

    function prepareFiltersParam() {
        const filters = []

        if (page && page > 1)
            filters.push(`page=${page}`)

        if (!stringIsEmpty(filterFullName))
            filters.push(`name=${filterFullName}`)

        if (!stringIsEmpty(filterNationalCode))
            filters.push(`national-code=${filterNationalCode}`)

        if (!stringIsEmpty(filterGroupName))
            filters.push(`group-name=${filterGroupName}`)

        if (!stringIsEmpty(filterAccountCode))
            filters.push(`group-code=${filterAccountCode}`)

        if (!stringIsEmpty(filterGroupCode))
            filters.push(`account-code=${filterGroupCode}`)

        if (!stringIsEmpty(filterPayAt))
            filters.push(`pay-at=${filterPayAt}`)

        if (!stringIsEmpty(filterSubmitAt))
            filters.push(`submit-at=${filterSubmitAt}`)

        if (!stringIsEmpty(filterPayerType) && filterPayerType !== "ALL")
            filters.push(`payer=${filterPayerType}`)

        navigate(addFiltersToUrl(filters))
    }

    function getTransactions() {
        setTableLoading(true)
        service.getAccountTransactions(
            fundID,
            page - 1,
            size,
            filterFullName,
            filterNationalCode,
            filterGroupName,
            filterAccountCode,
            filterGroupCode,
            dateIsNotValid(filterPayAt) ? null : convertPersianDateToUniversalDate(filterPayAt),
            dateIsNotValid(filterSubmitAt) ? null : convertPersianDateToUniversalDate(filterSubmitAt),
            filterPayerType,
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setTransactions([])
            response.data.map((item, index) => {
                setTransactions(prev => [
                    ...prev,
                    prepareRow(
                        ((page - 1) * size) + index + 1,
                        item.amount,
                        item.cleared,
                        item.createdAt,
                        item.currentBalance,
                        item.depositAccountId,
                        item.depositAccountNumber,
                        item.depositedAt,
                        item.depositedByManager,
                        item.depositedByMember,
                        item.enabled,
                        item.hasBeenDelayed,
                        item.id,
                        item.kind,
                        item.ownerFirstName,
                        item.ownerLastName,
                        item.ownerNationalCode,
                        item.receiptUrl,
                    )
                ])
            })
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    const [receiptUrl, setReceiptUrl] = useState("")
    const [selectedTransactionId, setSelectedTransactionId] = useState(-1)
    const [openReceiptDialog, setOpenReceiptDialog] = useState(false);

    const handleOpenReceiptDialog = () => setOpenReceiptDialog(true)
    const handleCloseReceiptDialog = () => {
        setReceiptUrl("")
        setSelectedTransactionId(-1)
        setOpenReceiptDialog(false)
    }

    function prepareRow(
        number,
        amount,
        cleared,
        createdAt,
        balance,
        depositAccountId,
        accountCode,
        depositedAt,
        depositedByManager,
        depositedByMember,
        enabled,
        hasBeenDelayed,
        id,
        kind,
        ownerFirstName,
        ownerLastName,
        payerNationalCode,
        receiptUrl) {
        return {
            number,
            id,
            payerFullName: `${ownerFirstName} ${ownerLastName}`,
            payerNationalCode,
            accountCode,
            amount: <RaikoShowPrice amount={amount} centerTextAlign/>,
            balance: <RaikoShowPrice amount={balance} centerTextAlign/>,
            depositedAt: convertUniversalDateTimeToPersianDateTime(depositedAt),
            kind: kind === "MANAGER_DEPOSIT" ? "مدیر سامانه" : "کاربر",
            depositedBy: depositedByManager && depositedByManager !== "" ? depositedByManager :
                depositedByMember && depositedByMember !== "" ? depositedByMember : "-",
            hasBeenDelayed: <RaikoCustomSimpleActiveDeActiveChip
                state={!hasBeenDelayed}
                activeStateTitle={"ندارد"}
                deActiveStateTitle={"دارد"}
            />,
            status: <RaikoCustomSimpleActiveDeActiveChip
                state={enabled}
                activeStateTitle={"فعال"}
                deActiveStateTitle={"غیرفعال"}
            />,
            access: <RaikoCustomTooltip title={"رسید تراکنش"}>
                <div
                    className={css`
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      cursor: pointer;
                    `}
                    onClick={_ => {
                        setReceiptUrl(receiptUrl)
                        setSelectedTransactionId(id)
                        handleOpenReceiptDialog()
                    }}
                >
                    <div className={"ic-receipt"}/>
                </div>
            </RaikoCustomTooltip>
        }
    }


    function handleChangePagination(newPage) {
        setPage(newPage + 1)
    }


    const [transactionDetailDialog, setTransactionDetailDialog] = useState(false)
    const openTransactionDetailDialog = () => setTransactionDetailDialog(true)
    const closeTransactionDetailDialog = () => {
        setTransactionDetailDialog(false)
        setSelectedTransactionId(-1)
    }

    function handleUpdateTable(updatedItem) {
        getTransactions()
        closeTransactionDetailDialog()
    }

    function handleDeleteAllFilters() {
        setPage(1)
        setFullName("")
        setNationalCode("")
        setGroupName("")
        setGroupCode("")
        setAccountCode("")
        setPayAt("")
        setSubmitAt("")
        setPayerType("")
    }

    function handleUpdateReceipt(receiptUrl, id) {
        getTransactions()
        handleCloseReceiptDialog()
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseReceiptDialog}
                open={openReceiptDialog}
                pageTitle={"رسید تراکنش"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <AccountMonthlyDepositReceipt
                    receiptUrl={receiptUrl}
                    transactionId={selectedTransactionId}
                    handleUpdateReceipt={handleUpdateReceipt}
                />
            </RaikoDefaultDialogPage>

            <RaikoDefaultDialogPage
                onClose={closeTransactionDetailDialog}
                open={transactionDetailDialog}
                pageTitle={"تراکنش ماهیانه"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <AccountMonthlyDepositNewTransaction
                    transactionId={selectedTransactionId}
                    handleAddNewTransactionToTable={_ => {
                    }}
                    handleUpdateTransactionInTable={handleUpdateTable}
                />
            </RaikoDefaultDialogPage>


            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(RouteHelper.AccountsTransactionsList.name, ""),
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"تراکنشات حساب"}
                                amount={totalItems}
                                hasCreateNewItem
                                createNewItemTitle={"تراکنش گروهی جدید"}
                                handleCreateNewItem={_ => {
                                    navigate(RouteHelper.AccountsNewTransaction.globalUrl)
                                }}
                                hasSecondaryButton
                                secondaryButtonTitle={"ویرایش تراکنش گروهی"}
                                secondaryButtonOnClick={_ => {
                                    navigate(RouteHelper.AccountsUpdateTransaction.globalUrl)
                                }}
                            />


                            <RaikoTableSearchContainer
                                hasFilter={true}
                                labelText={"نام و نام خانوادگی"}
                                placeHolder={"عبارت مورد نظر را وارد نمایید"}
                                setValue={setFullName}
                                value={fullName}
                                handleDeleteAllFilters={handleDeleteAllFilters}
                                filterStatus={
                                    !["ALL", undefined, null, ""].includes(filterPayerType.toString()) ||
                                    !stringIsEmpty(filterNationalCode) ||
                                    !stringIsEmpty(filterGroupName) ||
                                    !stringIsEmpty(filterGroupCode) ||
                                    !stringIsEmpty(filterAccountCode) ||
                                    !stringIsEmpty(filterPayAt) ||
                                    !stringIsEmpty(filterSubmitAt)
                                }
                            >
                                <RaikoGridOneColumn>
                                    <RaikoNumberInputOutlined
                                        labelText={"کد ملی"}
                                        value={nationalCode}
                                        setValue={setNationalCode}/>

                                    <RaikoMaterialOutlinedInput
                                        labelText={"نام گروه"}
                                        value={groupName}
                                        setValue={setGroupName}/>

                                    <RaikoNumberInputOutlined
                                        labelText={"کد گروه"}
                                        value={groupCode}
                                        setValue={setGroupCode}/>

                                    <RaikoNumberInputOutlined
                                        labelText={"شناسه حساب"}
                                        value={accountCode}
                                        setValue={setAccountCode}/>

                                    <RaikoDatePicker
                                        label={"تاریخ پرداخت"}
                                        date={payAt}
                                        setDate={setPayAt}/>

                                    <RaikoDatePicker
                                        label={"تاریخ ثبت"}
                                        date={submitAt}
                                        setDate={setSubmitAt}/>

                                    <RaikoCustomSelect
                                        labelText={"واریز کننده"}
                                        value={payerType}
                                        setValue={setPayerType}
                                        items={[
                                            raikoCustomSelectItemGenerator("ALL", "همه"),
                                            raikoCustomSelectItemGenerator("MANAGER", "مدیر"),
                                            raikoCustomSelectItemGenerator("MEMBER", "کاربر"),
                                        ]}
                                    />

                                </RaikoGridOneColumn>

                            </RaikoTableSearchContainer>

                            <RaikoCustomTable
                                header={header}
                                data={transactions}
                                isLoading={tableLoading}
                                pageCount={pageCount}
                                newPage={page}
                                handlePaginationChange={handleChangePagination}
                                rowClicked={id => {
                                    setSelectedTransactionId(id)
                                    openTransactionDetailDialog()
                                }}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "payerFullName",
        label: "نام و نام خانوادگی"
    }, {
        id: "payerNationalCode",
        label: "کدملی"
    }, {
        id: "accountCode",
        label: "شناسه حساب"
    }, {
        id: "amount",
        label: "مبلغ (ریال)"
    }, {
        id: "balance",
        label: "موجودی (ریال)"
    },
    {
        id: "depositedAt",
        label: "تاریخ پرداخت"
    }, {
        id: "kind",
        label: "نوع واریز"
    }, {
        id: "depositedBy",
        label: "واریز کننده"
    }, {
        id: "hasBeenDelayed",
        label: "تاخیر"
    },
    /* {
         id: "status",
         label: "وضعیت"
     },*/
    {
        id: "access",
        label: "دسترسی"
    },
]
